<template>
    <div class="share-pic-modal">
        <a-spin :spinning="loading">
            <div class="share-pic" id="share-pic" :style="{display:showShareHtml == true ? 'block' : 'none', width:'375px', height:'534px'}">
                <div class="content">
                    <div class="p-img">
                        <img :src="$store.state.assetUrl + info.img" alt="">
                    </div>
                    <div class="p-os">
                        <div class="plat-box">
                            <g-icon type="ios" v-if="plats.ios"></g-icon>
                            <g-icon type="web" v-if="plats.web"></g-icon>
                            <g-icon type="android" v-if="plats.android"></g-icon>
                            <g-icon type="windows" v-if="plats.windows"></g-icon>
                            <g-icon type="mac" v-if="plats.mac"></g-icon>
                            <g-icon type="linux" v-if="plats.linux"></g-icon>
                        </div>

                        <div class="promote">
                            {{ info.promote }}
                        </div>
                    </div>
                    <div class="p-name">
                        <div class="name text-ellipsis-2">{{info.name}}</div>
                        <div class="price"><span class="small">¥</span>{{info.price}}</div>
                    </div>
                    <div class="qrcode-box">
                        <img :src="info.qrcode_url" alt="">
                        <div class="step">
                            <div><span class="num">1</span> 右键保存发给好友</div>
                            <div><span class="num">2</span> 好友扫码即可购买</div>
                        </div>
                        <g-icon type="logo"></g-icon>
                    </div>
                </div>
            </div>
        </a-spin>
        <div id="canvas-container" v-show="!showShareHtml">
            <img :src="postUrl" alt="">
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
import gIcon from "./icon.vue"
export default {
    props: {
        value:{}
    },
    components: {
        gIcon
    },
    data () {
        return {
            loading:false,
            showShareHtml:true,
            info:{},
            plats:{mac:0, windows:0, linux:0, ios:0, android:0, web:0},
            postUrl:""
        }
    },
    watch:{
        value(val){
            this.create(val)
        }
    },
    mounted(){
        this.create(this.value)
    },
    destroyed(){
        this.$el.remove();
    },
    methods:{
        initPlats(){
            this.info.tags.map((v)=>{
                if(v.name.toLowerCase() == 'macos')this.plats.mac = 1;
                if(v.name.toLowerCase() == 'windows')this.plats.windows = 1;
                if(v.name.toLowerCase() == 'linux')this.plats.linux = 1;
                if(v.name.toLowerCase() == 'ios')this.plats.ios = 1;
                if(v.name.toLowerCase() == 'android')this.plats.android = 1;
                if(v.name.toLowerCase() == 'web')this.plats.web = 1;
            });
        },
        create(val){
            this.info = val
            if(!this.info.name){
                return
            }
            
            this.showShareHtml = true
            this.loading = true
            this.initPlats()
            let self = this;
            
            setTimeout(()=>{
                let dom = document.getElementById("share-pic")
                let canvas = document.createElement('canvas') // 创建一个canvas节点
                // /let container = document.getElementById("canvas-container")
                let scale = window.devicePixelRatio
                canvas.width = 375*scale
                canvas.height = 534*scale
                canvas.style.width = "375px"
                canvas.style.height = "534px"
                canvas.getContext('2d').scale(scale, scale)
                html2canvas(dom, {
                    scale:1,
                    canvas,
                    useCORS:true,
                    allowTaint:false,
                    dpi:300,
                    }).then((cvs) => {
                        self.showShareHtml = false
                        self.loading = false
                        self.postUrl = cvs.toDataURL("image/png")
                        cvs.remove()
                })
            },200)
        }
    }
}
</script>

<style scoped>
.share-pic-modal{
    display: inline-block;
    text-align: left;
}
.share-pic-modal .p-img{
    padding: 45px 30px;
    text-align: center;
    
}
.share-pic-modal .p-img img{
    width: 70%;
}
.share-pic-modal .p-name{
    display: flex;
    padding: 18px;
}
.share-pic-modal .p-name .name{
    width: calc(100% - 95px);
    color: rgba(0, 0, 0, 1);
    line-height: 1.3;
    font-size: 13px;
    padding-right: 10px;
}
.share-pic-modal .p-name .price{
    width: 95px;
    font-size: 20px;
    color: #ff4d4f;
    text-align: right;
    font-weight: 500;
    position: relative;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
}

.share-pic-modal .qrcode-box{
    display: flex;
    padding: 14px 25px 30px 25px;
}
.share-pic-modal .qrcode-box img{
    width: 50px;
height: 50px;
}
.share-pic-modal .qrcode-box .step{
    padding: 1px 10px;
    font-size: 12px;
    width: calc(100% - 100px);
    color: rgba(0, 0, 0, 0.5);
}
.share-pic-modal .qrcode-box .step>div:first-child{
    margin-bottom: 8px;
}
.share-pic-modal .qrcode-box .step .num{
    display: inline-block;
    text-align: center;
    line-height: 10px;
    height: 14px;
    width: 14px;
    margin-right: 3px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.3);
    vertical-align: text-bottom;
    font-size: 12px;
}
.share-pic-modal .qrcode-box .logo{
    width: 50px;
    height: 50px;
    text-align: center;
    font-size: 40px;
    line-height: 51px;
    color: #ff4d4f;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}
.share-pic-modal .share-pic{
    padding: 35px;
    background: rgba(0, 0, 0, 0.08);
}
.share-pic-modal .share-pic .content{
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
    border-radius: 15px;
    overflow: hidden;
    background: #fff;
}
.share-pic-modal .p-os{
    background: #244583;
    color: #fff;
    display: flex;
    padding: 2px 0;
}
.share-pic-modal .p-os .plat-box{
    flex: 1;
    text-align: center;
    margin-left: 0;
    font-size: 14px;
    padding-top: 1px;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
}
.share-pic-modal .p-os .plat-box .icon{
    line-height: 18px;
    margin: 0 4px;
    font-size: 14px;
}
.share-pic-modal .p-os .promote{
    flex: 1;
    text-align: center;
    font-size: 12px;
}
.share-pic-modal .title{
    font-family:'Courier New', Courier, monospace;
    text-align: center;
    padding-top: 20px;
    font-size: 16px;
    color: #000;
}
#canvas-container img{
    height: 534px;
    width: 375px;
}
</style>